import React from 'react';
import BlockUi from 'react-block-ui';

import { withStyles } from 'src/app/helpers/styles';

interface MyProps {
  blocking: boolean;
  className?: string;
}

@withStyles(require('./LoaderBlock.scss'))
export class LoaderBlock extends React.Component<MyProps> {
  render(): JSX.Element {
    const { blocking, children, className } = this.props;
    return (
      <BlockUi className={className} blocking={blocking}>
        {children}
      </BlockUi>
    );
  }
}
